import { compact } from 'lodash'
import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import type { UserRole } from '../types/user'

type User = {
  firstNm?: string
  lastNm?: string
}

export default function formatUserName(user?: User) {
  if (!user) return
  return compact([user.firstNm, user.lastNm]).join(' ')
}

// Function overloads to provide conditional return types
type UserRoleFormatter = {
  (role: UserRole): string
  (role?: UserRole): string | undefined
}

export function useUserRoleFormatter() {
  const t = useTranslations('data.users')
  return useCallback((role?: UserRole) => (role ? t(`roles_${role}`) : undefined), [t]) as UserRoleFormatter
}

export type AccessLevel = 'standard' | 'readOnly'

export function toAccessLevel(readOnly?: boolean): AccessLevel {
  return readOnly ? 'readOnly' : 'standard'
}

export function useAccessLevelFormatter() {
  const t = useTranslations('data.users')
  return useCallback((accessLevel: AccessLevel) => t(`accessLevels_${accessLevel}`), [t])
}
